export default __webpack_public_path__ + "static/media/profileIcon.31de5dce.svg";